import { render, staticRenderFns } from "./ModalCuentraAtrasAvisoCarrito.vue?vue&type=template&id=15a1854e"
import script from "./ModalCuentraAtrasAvisoCarrito.vue?vue&type=script&lang=js"
export * from "./ModalCuentraAtrasAvisoCarrito.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports